import React, { FC, Suspense } from "react"
import type { SchemaFormPlaygroundProps } from "resha"

const ReshaSchemaFormPlayground = React.lazy(async () => {
    return import("resha").then(resha => ({
        default: resha.SchemaFormPlayground
    }))
})

export const SchemaFormPlayground: FC<
    SchemaFormPlaygroundProps & { fallback: JSX.Element }
> = ({ fallback, ...props }) => {
    return (
        <Suspense fallback={fallback}>
            <ReshaSchemaFormPlayground {...props} />
        </Suspense>
    )
}
